module.exports = __webpack_public_path__ + "img/gg.7d311b04.svg";